import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const FilterArrowLeftContainer = styled.div<
  React.CSSProperties & {
    anonymous: boolean;
    enabled: boolean;
    hasSearchBar: boolean;
  }
>`
  align-items: center;
  background: rgba(40, 40, 40, 0.9);
  border-radius: ${Screen.widthRatio * 26}px;
  display: flex;
  justify-content: center;
  left: ${(props) => Screen.widthRatio * (props.hasSearchBar ? 640 : 134)}px;
  opacity: ${(props) => {
    return props.enabled ? 0.5 : 0;
  }};
  padding-right: ${Screen.widthRatio * 8}px;
  position: absolute;
  top: ${(props) =>
    props.hasSearchBar ? 22 * Screen.widthRatio : 20 * Screen.widthRatio}px;
  height: ${Screen.widthRatio * 57}px;
  width: ${Screen.widthRatio * 49}px;
  &:hover {
    opacity: ${(props) => {
      return props.enabled ? 1 : 0;
    }};
  }
`;

export default withAnimation(FilterArrowLeftContainer);
